import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const Location = (props: Props) => (
  <Svg viewBox='0 0 25 25' fill='none' {...props}>
    <Path
      d='M12.5 2.08333C8.46879 2.08333 5.20837 5.34374 5.20837 9.37499C5.20837 14.8437 12.5 22.9167 12.5 22.9167C12.5 22.9167 19.7917 14.8437 19.7917 9.37499C19.7917 5.34374 16.5313 2.08333 12.5 2.08333ZM7.29171 9.37499C7.29171 6.49999 9.62504 4.16666 12.5 4.16666C15.375 4.16666 17.7084 6.49999 17.7084 9.37499C17.7084 12.375 14.7084 16.8646 12.5 19.6667C10.3334 16.8854 7.29171 12.3437 7.29171 9.37499Z'
      fill='#FE5000'
    />
    <Path
      d='M12.5 11.9792C13.9383 11.9792 15.1042 10.8132 15.1042 9.37499C15.1042 7.93675 13.9383 6.77083 12.5 6.77083C11.0618 6.77083 9.89587 7.93675 9.89587 9.37499C9.89587 10.8132 11.0618 11.9792 12.5 11.9792Z'
      fill='#FE5000'
    />
  </Svg>
)
